export default __webpack_public_path__ + "static/fa-solid-900-9b4d14a5508e9cc4ca886daa383451f8.ttf";